import { XMarkIcon } from '@heroicons/react/24/outline';
import * as Modal from '@radix-ui/react-dialog';
import { forwardRef, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import * as DialogPrimitive from "@radix-ui/react-dialog"

interface ModalProps extends Modal.DialogContentProps {
	children: ReactNode;
	contentClass?: string;
}
const DialogOverlay = forwardRef<React.ElementRef<typeof Modal.Overlay>, React.ComponentPropsWithoutRef<typeof Modal.Overlay>>(({ className, ...props }, ref) => (
	<Modal.Overlay ref={ref} className={twMerge('empreender-anim fixed inset-0 z-50 bg-gray-500/75 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=open]:duration-200 data-[state=closed]:duration-150', className)} {...props} />
));
DialogOverlay.displayName = Modal.Overlay.displayName;

type DialogDescriptionProps = React.HTMLAttributes<HTMLParagraphElement>;

const DialogDescription = forwardRef<HTMLParagraphElement, DialogDescriptionProps>(({ className, ...props }, ref) => <Modal.Description ref={ref} className={twMerge('text-sm text-muted-foreground', className)} {...props} />);

DialogDescription.displayName = Modal.Description.displayName;

const tituloModal = 'text-lg font-semibold leading-tight text-gray-900 pr-10';

export const ModalTitle = forwardRef<React.ElementRef<typeof Modal.Title>, React.ComponentPropsWithoutRef<typeof Modal.Title>>(({ className, ...props }, ref) => <Modal.Title ref={ref} className={twMerge(tituloModal, className)} {...props} />);
ModalTitle.displayName = Modal.Title.displayName;

export function DialogTitle({
	className,
	...props
}: React.ComponentProps<typeof DialogPrimitive.Title>) {
	return <DialogPrimitive.Title data-slot='dialog-title' className={twMerge(tituloModal, className)} {...props} />;
}

export const ModalFooter = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
	<div className={twMerge('flex flex-col-reverse items-center gap-2 sm:flex-row sm:justify-end sm:space-x-2 sm:gap-0', className)} {...props} />
);
ModalFooter.displayName = 'ModalFooter';
const ModalContent = ({ children, ...props }: ModalProps) => {

	return (
		<>
			<Modal.Portal>
				<DialogOverlay />
				<Modal.Content
					{...props}
					className={twMerge(
						'empreender-anim !outline-0 custom-scroll fixed left-[50%] top-[50%] h-[80vh] overflow-hidden rounded-md z-50 bg-white grid w-3/6 translate-x-[-50%] translate-y-[-50%] gap-4 border p-6 data-[state=open]:duration-200 data-[state=closed]:duration-150 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-1/2 data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-1/2',
						props.className
					)}>

					{children}
		
					<Modal.Close asChild>
						<button
							className='absolute right-4 top-4 inline-flex size-8 appearance-none items-center justify-center rounded-full text-gray-900 outline-none transition-colors hover:bg-gray-100 active:scale-95'
							aria-label='Fechar'>
							<XMarkIcon className='size-5' />
						</button>
					</Modal.Close>
				</Modal.Content>
			</Modal.Portal>
		</>
	);
};

export default ModalContent;
